<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.batchName" clearable placeholder="搜索考试名称"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="id" label="序号" width="80">
          <template slot-scope="scope">
            {{1+page.pageSize*(page.pageNum-1)+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="batchName" label="考试名称"></el-table-column>
        <el-table-column prop="evaluateStatus" label="状态">
          <template slot-scope="scope">
            {{$enums.evaluateStatus[scope.row.evaluateStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push({path:'./setting-edit',query:{batchId:scope.row.batchId,settingsId:scope.row.settingsId}})">设置模板</el-button>
            <el-button size="mini" type="text" @click="$router.push({path:'./room',query:{batchId:scope.row.batchId}})">设置考场</el-button>
            <!--            <el-button size="mini" type="text" @click="edit(scope.row)">设置考场</el-button>-->
            <!--            <el-button size="mini" type="text" @click="$router.push({path:'./room-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,isFill:scope.row.roomNum>0?1:0}})">-->
            <!--              编辑评委分组-->
            <!--            </el-button>-->
            <el-button size="mini" type="text" @click="allot(scope.row)">分配考生</el-button>
            <el-button v-if="false" size="mini" type="text" style="color: #E91212;" @click="reset(scope.row)">重置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.row?'编辑':'创建')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="800px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()" style="max-height: 500px;overflow-y: auto;"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './room-name-edit'

export default {
  name: 'list',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchName: '' },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null, title: '评分模板' }
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.GradeSetting.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async allot (row) {
      await this.$HTTP.GradeRoom.allot(row.batchId)
      this.$message({ type: 'success', message: '操作成功' })
      await this.getPage()
    },
    async reset (row) {
      try {
        let confirm = await this.$confirm('重置后之前评分数据将会被清除，确定要重置吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          this.$message({ type: 'success', message: '操作成功' })
          // await this.$HTTP.ApiBatch.del(row.batchId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    // async editExamRoom (row) {
    //   // debugger
    //   if (row.evaluateStatus != 0) {
    //     this.$router.push(`./room?batchId=${row.batchId}`)
    //   } else {
    //     this.$message({ type: 'error', message: '请先设置评分模板' })
    //   }
    //   // $router.push({path:'./room',query:{batchId:scope.row.batchId}})
    // }
  }
}
</script>
